import React from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import translations from '../../constants/translations.json';
import { useDataContext } from '../../context/data';

const inputClassName =
  'w-full py-3 px-4 text-sm bg-[#f5f5f5] border border-transparent rounded-[10px] outline-none text-[#333] transition-[border-color] duration-200 focus:border-primary';

const labelClassName =
  'text-[11px] font-semibold text-[#555] uppercase tracking-[0.5px] mb-1.5 block';

const ProfileInputs = ({ userProfile, handleChange }) => {
  const { language } = useDataContext();

  return (
    <div className="flex flex-col gap-4">
      <div>
        <label className={labelClassName}>{translations[language]?.profile_input_name}</label>
        <input
          type="text"
          className={inputClassName}
          value={userProfile?.profile?.name || ''}
          onChange={(e) => handleChange('name', e.target.value)}
          autoComplete="name"
        />
      </div>

      <div>
        <label className={labelClassName}>{translations[language]?.profile_input_email}</label>
        <input
          type="email"
          className={inputClassName}
          value={userProfile?.profile?.email || ''}
          onChange={(e) => handleChange('email', e.target.value)}
          autoComplete="email"
        />
      </div>

      <div>
        <label className={labelClassName}>
          {translations[language]?.profile_input_mobile_number}
        </label>
        <PhoneInput
          country={userProfile?.profile?.countryCode?.cca2?.toLowerCase() || 'dk'}
          value={userProfile?.profile?.mobilenumber || ''}
          onChange={(value) => handleChange('mobilenumber', value)}
          inputStyle={{
            width: '100%',
            paddingLeft: 60,
            fontSize: 14,
            background: '#f5f5f5',
            border: '1px solid transparent',
            borderRadius: 10,
            outline: 'none',
            color: '#333',
          }}
          buttonStyle={{
            background: 'transparent',
            border: 'none',
            borderRight: 'none',
            borderRadius: '10px 0 0 10px',
            paddingLeft: 0,
            paddingRight: 0,
          }}
          dropdownStyle={{ borderRadius: 10, boxShadow: '0 4px 16px rgba(0,0,0,0.1)' }}
          enableSearch
          searchPlaceholder={translations[language]?.search}
        />
      </div>
    </div>
  );
};

export default ProfileInputs;
